import type { IExtractRouteParamMap } from "@/routes/types";
import { createPaths } from "@/routes/utils";

const baseRoute = `/student/profile`;

export const profileRoutesObj = {
  home: baseRoute,
} as const;

export type IProfileRouteParams = IExtractRouteParamMap<
  typeof profileRoutesObj
>;

export const profilePath = createPaths<
  typeof profileRoutesObj,
  IProfileRouteParams
>(profileRoutesObj);
